interface StatusIconNewProps {
  /** Stroke color; white when selected, #999999 when inactive. */
  strokeColor?: string;
}

/**
 * Outline status (refresh) icon for header navigation tabs.
 *
 * @param strokeColor - Icon stroke color (defaults to white for active state)
 */
const StatusIconNew = ({ strokeColor = "white" }: StatusIconNewProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.66699 11.6667C1.66699 11.6667 1.76809 12.3744 4.69702 15.3033C7.62596 18.2322 12.3747 18.2322 15.3036 15.3033C16.3414 14.2656 17.0114 12.9994 17.3138 11.6667M6.66699 11.6667H1.66699V16.6667M18.3337 8.33333C18.3337 8.33333 18.2326 7.62563 15.3036 4.6967C12.3747 1.76777 7.62596 1.76777 4.69702 4.6967C3.6593 5.73443 2.98924 7.0006 2.68685 8.33333M13.3337 8.33333H18.3337V3.33333"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StatusIconNew;
